import React, { useEffect } from "react";
import { Box, Typography, Tooltip, IconButton, Button } from "@mui/material";
import { FileCopy } from "@mui/icons-material";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

import { useDispatch, useSelector } from "react-redux";
import { selectRates } from "../../redux/state/rates/ratesSelector";
import { fetchRates } from "../../redux/state/rates/ratesSlice";

import ordersStyles from "../../Pages/Orders/Orders.styles";
import { selectUserData } from "../../redux/state/authReduser/authentification.selectors";
import Notiflix from "notiflix";
import { bot1 } from "../../srevices/contacts";

function OrderDetails({ orderDetails, theme, handleCopy, copiedWallet }) {
  const ratesCurrent = useSelector(selectRates);
  const userData = useSelector(selectUserData);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchRates());
  }, [dispatch]);

  useEffect(() => {
    if (userData?.discount > 0) {
      Notiflix.Notify.success(`Ваша персональная скидка: ${userData.discount}%`);
    }
    if (userData?.balance > 0) {
      Notiflix.Notify.success(`Ваш баланс равен: ${userData.balance} руб`);
    }
  }, [userData?.discount]);

  const timeLeft = new Date(orderDetails?.expiresAt) - new Date();
  const validTimeLeft = timeLeft > 0 ? timeLeft / 1000 : 0;

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  const paymentNetworks = {
    BTC: "Bitcoin",
    USDT: "TRC-20",
    LTC: "Litecoin",
  };

  const getConvertedPrice = () => {
    if (!orderDetails || !orderDetails.price) return "Загрузка...";

    const { price, paymentMethod } = orderDetails;
    if (!ratesCurrent) return "Загрузка...";

    let finalPrice = price;

    if (userData?.discount) {
      finalPrice -= (finalPrice * userData.discount) / 100;
    }

    if (paymentMethod === "По карте + комиссия ") {
      const balance = userData?.balance ?? 0;
      if (balance > 0) {
        Notiflix.Notify.success("Цена указана с учетом вашего баланса");
      }
      finalPrice = balance >= finalPrice ? 0 : finalPrice - balance;
    }

    if (paymentMethod === "BTC") {
      return `${(finalPrice / ratesCurrent.BTC).toFixed(10)} BTC (${paymentNetworks.BTC})`;
    }
    if (paymentMethod === "USDT") {
      return `${(finalPrice / ratesCurrent.USDT).toFixed(5)} USDT (${paymentNetworks.USDT})`;
    }
    if (paymentMethod === "LTC") {
      return `${(finalPrice / ratesCurrent.LTC).toFixed(5)} LTC (${paymentNetworks.LTC})`;
    }
    return `${finalPrice.toFixed(2)} RUB`;
  };

  const handlePaymentRedirect = () => {
    window.open(bot1);
  };

  return (
    <Box sx={{ marginBottom: 2 }}>
      <Typography variant="h6">Продукт:</Typography>
      <Typography variant="body1" sx={ordersStyles(theme).cardContent}>
        {orderDetails?.productName}
      </Typography>

      <Typography variant="h6">Вес:</Typography>
      <Typography variant="body1" sx={ordersStyles(theme).subheading}>
        {orderDetails?.weight} г
      </Typography>

      <Typography variant="h6">Район:</Typography>
      <Typography variant="body1" sx={ordersStyles(theme).subheading}>
        {orderDetails?.district}
      </Typography>

      <Typography variant="h6">Метод оплаты:</Typography>
      <Typography variant="body1" sx={ordersStyles(theme).subheading}>
        {orderDetails?.paymentMethod} {paymentNetworks[orderDetails?.paymentMethod] ? `(Сеть: ${paymentNetworks[orderDetails.paymentMethod]})` : ""}
      </Typography>

      <Typography variant="h6">Сумма:</Typography>
      <Typography variant="body1" sx={ordersStyles(theme).subheading}>
        {getConvertedPrice()}
      </Typography>

      {orderDetails?.paymentMethod === "По карте + комиссия " ? (
        <Box sx={{ textAlign: "center", mt: 2 }}>
        <Button
          onClick={handlePaymentRedirect}
          sx={{
            padding: "14px 28px",
            fontSize: "20px",
            fontWeight: "bold",
            color: "#fff",
            background: "linear-gradient(90deg, #ff0000, #0000ff)",
            borderRadius: "5px",
            textTransform: "uppercase",
            border: "2px solid #fff",
            transition: "0.3s",
            "&:hover": {
              background: "linear-gradient(90deg, #ff0000, #00ff00)",
              boxShadow: "0px 0px 25px 5px rgba(255, 0, 0, 0.8)",
              transform: "scale(1.05)",
            },
          }}
        >
          Перейти к оплате
        </Button>
        <Typography sx={{ mt: 2, fontSize: "14px", color: "#fff" }}>
          Инструкция ниже под кнопками "Продлить" "Отменить"
        </Typography>
      </Box>
      ) : (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6">Кошелек:</Typography>
            <Typography variant="body1" sx={ordersStyles(theme).subheading}>
              {orderDetails?.wallet}
            </Typography>
          </Box>
          <Tooltip title={copiedWallet ? "Скопировано!" : "Копировать кошелек"}>
            <IconButton
              onClick={() => handleCopy(orderDetails?.wallet, copiedWallet)}
              sx={{ ml: 1 }}
            >
              <FileCopy />
            </IconButton>
          </Tooltip>
        </Box>
      )}

      <Typography variant="h6">Оставшееся время:</Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          marginTop: 2,
        }}
      >
        {validTimeLeft > 0 ? (
          <CountdownCircleTimer
            isPlaying
            duration={validTimeLeft}
            colors={["#004777", "#F7B801", "#A30000", "#A30000"]}
            colorsTime={[7, 5, 2, 0]}
            size={120}
            strokeWidth={10}
            trailColor="#d6d6d6"
          >
            {({ remainingTime }) => (
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  color: theme.palette.text.primary,
                  fontSize: { xs: "1.5rem", sm: "2rem" },
                }}
              >
                {formatTime(remainingTime)}
              </Typography>
            )}
          </CountdownCircleTimer>
        ) : (
          <Typography variant="h6" sx={{ color: "#A30000" }}>
            Время вышло
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default OrderDetails;
